module.exports = __webpack_public_path__ + "img/minus-icon.e9480d5d.svg";